import {CDN_URL} from '../config';

export function formatFileForFeatureImageFromSetka(file) {
  if (!file || !file._id) return {};
  return {
    ...file,
    liveURL: file.url?.replace(CDN_URL, `${CDN_URL}/fit-in/300x0`) || '',
  };
}
export function formatFileForSetka(f) {
  return {
    id: f._id,
    _id: f._id,
    name: f.name,
    url: `${f.liveURL}`,
    thumbUrl: thumbFromLiveURL(f.liveURL, 200, 0),
    // sizes: [], // not work on editor, it still use origin image, and `blog` already reset the sizes itself.
    sizes: [
      {width: 420, height: 420, url: thumbFromLiveURL(f.liveURL, 420)},
      {width: 700, height: 700, url: thumbFromLiveURL(f.liveURL, 700)},
      {width: 900, height: 900, url: thumbFromLiveURL(f.liveURL, 900)},
    ],
  };
}
export function formatFilesForSetka(files) {
  return files
    .filter((f) => {
      const ext = f.name.split('.').pop().toLowerCase();
      return (
        ['jpg', 'jpeg', 'png', 'webp'].includes(ext) && f.folderType === 'FILE'
      );
    })
    .map((f) => formatFileForSetka(f));
}
export function thumbFromLiveURL(liveURL, width = 0, height = 0) {
  // f.liveURL.replace(CDN_URL, `${CDN_URL}/fit-in/200x0`)
  if (!liveURL) return '';
  return liveURL.replace(CDN_URL, `${CDN_URL}/fit-in/${width}x${height}`);
}
